var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      attrs: {
        editTitle: "Portal-Aufgabe bearbeiten",
        createTitle: "Neue Portal-Aufgabe",
        isLoading: _vm.isLoading,
      },
    },
    [
      _c("table", [
        _c("tr", [
          _c("th", [
            _c(
              "label",
              { staticClass: "label", attrs: { for: "templateName" } },
              [_vm._v("Aufgabe:")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("todo-name-select", {
                attrs: { id: "templateName" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c(
              "label",
              { staticClass: "label", attrs: { for: "templateDescription" } },
              [_vm._v("Beschreibung:")]
            ),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.description,
                  expression: "form.description",
                },
              ],
              staticClass: "textarea",
              attrs: { id: "templateDescription", rows: "2" },
              domProps: { value: _vm.form.description },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "description", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("label", { staticClass: "label" }, [_vm._v("Fälligkeit:")]),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c(
                "toggle-switch",
                {
                  model: {
                    value: _vm.form.dueDateMode,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "dueDateMode", $$v)
                    },
                    expression: "form.dueDateMode",
                  },
                },
                _vm._l(_vm.dueDateModeOptions, function (mode) {
                  return _c(
                    "option",
                    { key: mode.key, domProps: { value: mode.key } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(mode.value) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.form.dueDateMode === "none"
                ? _c("p", { staticClass: "help" }, [
                    _vm._v(
                      "\n                    Ohne Datum entsteht ein reiner Checklisten-Punkt — der Kunde setzt\n                    das Datum selbst.\n                "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.form.dueDateMode !== "none"
          ? _c("tr", [
              _c("th", [
                _c(
                  "label",
                  { staticClass: "label", attrs: { for: "templateDays" } },
                  [_vm._v(_vm._s(_vm.daysLabel) + ":")]
                ),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.form.daysOffset,
                      expression: "form.daysOffset",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "input",
                  attrs: { type: "number", min: "0", id: "templateDays" },
                  domProps: { value: _vm.form.daysOffset },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form,
                        "daysOffset",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _vm._v(" "),
                _vm.form.dueDateMode === "before_start"
                  ? _c("p", { staticClass: "help" }, [
                      _vm._v(
                        "\n                    Reisen ohne Startdatum bekommen die Aufgabe ohne Frist.\n                "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("label", { staticClass: "label" }, [_vm._v("Zuständig:")]),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c(
                "toggle-switch",
                {
                  model: {
                    value: _vm.form.autoAssignToCreator,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "autoAssignToCreator", $$v)
                    },
                    expression: "form.autoAssignToCreator",
                  },
                },
                [
                  _c("option", { domProps: { value: true } }, [
                    _vm._v("Ersteller der Reise"),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: false } }, [
                    _vm._v("niemand"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c(
              "label",
              { staticClass: "label", attrs: { for: "templateSort" } },
              [_vm._v("Reihenfolge:")]
            ),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.form.sortOrder,
                  expression: "form.sortOrder",
                  modifiers: { number: true },
                },
              ],
              staticClass: "input",
              attrs: { type: "number", id: "templateSort" },
              domProps: { value: _vm.form.sortOrder },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "sortOrder", _vm._n($event.target.value))
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "help" }, [
              _vm._v(
                "In 10er-Schritten vergeben, dann bleibt Platz zum Einsortieren."
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_c("label", { staticClass: "label" }, [_vm._v("Aktiv:")])]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c(
                "toggle-switch",
                {
                  model: {
                    value: _vm.form.active,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "active", $$v)
                    },
                    expression: "form.active",
                  },
                },
                [
                  _c("option", { domProps: { value: true } }, [_vm._v("Ja")]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: false } }, [
                    _vm._v("Nein"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _c("label", { staticClass: "label" }, [_vm._v("Hinzufügen:")]),
          ]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c(
                "toggle-switch",
                {
                  model: {
                    value: _vm.addToExistingOrders,
                    callback: function ($$v) {
                      _vm.addToExistingOrders = $$v
                    },
                    expression: "addToExistingOrders",
                  },
                },
                [
                  _c("option", { domProps: { value: false } }, [
                    _vm._v("nur in neue Reisen"),
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: true } }, [
                    _vm._v("auch in bestehende Reisen"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "help" }, [
                _vm._v(
                  "\n                    Bestehende Reisen: alle im Portal sichtbaren Reisen dieses Kunden,\n                    die noch nicht begonnen haben. Mehrfaches Hinzufügen erzeugt keine\n                    Duplikate.\n                "
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }